module.exports = __webpack_public_path__ + "assets/img/new-22-logo.40366f10.jpg";